export const image_url = (image) => image.url || image;

export const image_thumbnail = (image) => image.thumbnail || image_url(image);
